export type ReportMainTabState = '상세 보기' | 'AI 총평';
export type ReportSubTabState = 'default' | 'contents' | 'student' | 'ai-lang' | 'used-sentence';
export interface StntReport {
    publishTab: string; // 발행 탭 상태 (돌아가기 시 사용)
    stntId?: string; // 학생 id
    setsId?: string; // 세트 id
    nickname?: string; // 닉네임 id
    usage?: string; // 용도
    targetId?: number; // 평가 / 과제 id
    mainTab: ReportMainTabState; // 선택된 메인 탭 상태
    subTab: ReportSubTabState; // 선택된 테이블 헤더 탭 상태
    thumbListIdx?: number; // 선택된 섬네일 리스트 인덱스
    stntsListIdx?: number; // 선택된 학생 리스트 인덱스
    claId: string;
    textbkId: number;
}

export const reportMainTabStateTypeGuard = (tab: string): tab is ReportMainTabState => {
    return tab === '상세 보기' || tab === 'AI 총평';
};

export const reportSubTabStateTypeGuard = (tab: string): tab is ReportSubTabState => {
    return (
        tab === 'default' ||
        tab === 'contents' ||
        tab === 'student' ||
        tab === 'ai-lang' ||
        tab === 'used-sentence'
    );
};
